import * as React from 'react'
import { useEffect, useMemo, useState, useRef } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";

const FilteringComponent = ({
    analystsListQuery,
    totalEntitiesQuery,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        successorAnalyst: null,
        parent: null
    });
    const initRef = useRef(false);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'successorAnalyst',
                title: 'Analyst',
                icon: <i className="ri-user-line" />,
                isLoading: analystsListQuery.isFetching,
                defaultValue: tableFilters?.successorAnalyst,
                data: analystsListQuery.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return `${item.first_name} ${item.last_name}`
                }
            },
            {
                type: 'radio_list',
                name: 'parent',
                title: 'Parent Entity',
                icon: <i className="ri-git-branch-line" />,
                isLoading: totalEntitiesQuery.isFetching,
                defaultValue: tableFilters?.parent,
                data: totalEntitiesQuery.data?.legalEntities || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            },
        ]
    }, [
        tableFilters,
        analystsListQuery.isFetching,
        analystsListQuery.data,

        totalEntitiesQuery.isFetching,
        totalEntitiesQuery.data?.legalEntities
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}

            if ('successorAnalyst' in filters) {
                result.successorAnalyst = filters.successorAnalyst !== 'all' ? filters.successorAnalyst : undefined
            }

            if ('parent' in filters) {
                result.parent = filters.parent !== 'all' ? filters.parent : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                successorAnalyst: null,
                parent: null
            })
        }
    }

    useEffect(() => {
        if(!initRef.current){
            initRef.current = true;
            return;
        }

        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='successorAnalyst'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent)
